<template>
  <div class="box8-page">
    <div class="page-title">
      <h2>该全则全 账号运营需要的知识全部送</h2>
      <p>只花一次钱，解决你IP带货账号所有问题！<br/>（前200份免费送，送完为止）</p>
    </div>

    <div class="page-cont">
      <swiper :options="swiperOption" ref="mySwiper" class="swiperitems">
        <swiper-slide
          class="swiperwrap"
          v-for="(item, index) in list"
          :key="index"
        >
          <div class="slide-cont">
            <h2>{{ item.name }}</h2>
              <div class="num">{{ '0' + (index + 1) }}</div>
              <div class="line"></div>
              <div class="cont-title">
                <div class="img-mask">
                  <img src="../../../assets/coursePage/newMedia2/box7/icon-02.png" alt="">
                </div>
                <span>学后收获</span>
              </div>
              <div class="info">{{ item.info1 }}</div>
              <div class="cont-title">
                <div class="img-mask">
                  <img src="../../../assets/coursePage/newMedia2/box7/icon-03.png" alt="">
                </div>
                <span>可解决的现实问题</span>
              </div>
              <ul>
                <li v-for="(v1, i1) in item.info2" :key=" i1 + 'info2-' + index">{{ v1 }}</li>
              </ul>
          </div>
        </swiper-slide>
      </swiper>
      <div class="swiper-pagination-box8"></div>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
  export default {
    name: '',
    components: {
      swiper,
      swiperSlide,
    },
    data() {
      return {
        swiperOption: {
          spaceBetween: 18,
          autoplay: true,
          centeredSlides: true,
          slidesPerView: "auto",
          coverflowEffect: {
            slideShadows: true, // 页面阴影效果
            stretch: 20, // 拉伸   图片间左右的间距和密集度
            modifier: 0.9, // 修正值 该值越大前面的效果越明显
          },
          pagination: {
            el: ".swiper-pagination-box8",
          },
        },
        list:[
          {
            name: '如何选品',
            info1: '掌握如何选品。',
            info2: [
              '掌握通过什么工具进行选品，以及怎么选品、选品中需要注意的问题。'
            ]
          },
          {
            name: '拍摄',
            info1: '掌握拍摄基本技能。',
            info2: [
              '解决学员拍摄的基本技能提升，包括景别、构图、运镜、光线技能；',
              '掌握具体的拍摄方法：三段摇拍摄、推进式拍摄、剧情拍摄、过肩拍摄技巧等。'
            ]
          },
          {
            name: '剪辑',
            info1: '掌握剪映剪辑技巧。',
            info2: [
              '解决学员不会用剪辑软件剪辑包装作品的问题。通过学习剪映各种效果制作技能，可获得剪辑、制作作品能力。'
            ]
          },
          {
            name: '前3秒设计50招',
            info1: '获得更多吸睛开头设计的方法。',
            info2: [
              '解决学员视频开头不吸引人的难题，通过50招前3秒的设计方法，可快速提升视频5秒完播数据。'
            ]
          },
          {
            name: '直播全流程',
            info1: '掌握直播运营必备技能，包括开场直播话术、开价话术、转款话术、爆款直播间拆解方法、直播间数据分析与复盘能力。',
            info2: [
              '解决学员不知道如何做直播内容撰写的问题；',
              '解决学员不会做直播数据分析复盘问题。'
            ]
          },
          {
            name: '本地同城流量最新玩法',
            info1: '掌握本地同城账号的运营方法，包括入驻、团单设置及核销、团单视频拍摄公式、如何获取同城搜索流量、本地地推使用方法等。',
            info2: [
              '解决学员不会做本地同城账号运营的问题，解决从入驻到上架团单，到生产适合团单销售，到视频/推广，到运营等各类问题。'
            ]
          },
          {
            name: '抖店运营',
            info1: '掌握抖店必备的运营技能，包括小店入驻、产品上架、商品卡搜索流量布局、数据分析等。',
            info2: [
              '解决学生不会做抖店商品卡流量获取问题，以及抖店整体运营数据分析的问题；',
              '学员通过课程学习掌握抖店运营的各项能力。'
            ]
          },
        ]
      }
    }
  }
</script>

<style lang="scss" scoped>
.box8-page{
  padding: 80px 0;
  background-image: url(../../../assets/coursePage/newMedia2/box8/box8-bg.png);
  background-size: cover;

  .page-cont {
    position: relative;
    padding-bottom: 38px;
    margin-top: 60px;
    .swiper-slide {
      width: 630px;
      height: 536px;
      .slide-cont{
        width: 100%;
        height: 100%;
        background: #fff;
        padding: 47px 50px 0;
        position: relative;
        box-sizing: border-box;
        border-radius: 20px;
        h2{
          font-family: PingFang-SC-Bold;
          font-size: 30px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 30px;
          letter-spacing: 1px;
          color: #ff3377;
        }
        .num{
          position: absolute;
          top: 31px;
          right: 29px;
          font-family: PingFang-SC-Heavy;
          font-size: 72px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 48px;
          letter-spacing: 0px;
          color: #ff4180;
          opacity: 0.08;
        }
        .line{
          width: 300px;
          height: 2px;
          background-image: linear-gradient(90deg, 
            #ffb2cc 0%, 
            #ffffff 100%);
            margin-top: 30px;
        }
        .cont-title{
          margin-top: 30px;
          display: flex;
          align-items: center;
          .img-mask{
            width: 21px;
            margin-right: 6px;
            img{
              height: 21px;
            }
          }
          span{
            font-family: PingFang-SC-Bold;
            font-size: 28px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 28px;
            letter-spacing: 1px;
            color: #191c47;
          }
        }
        .info{
          margin-top: 27px;
          font-family: PingFang-SC-Regular;
          font-size: 24px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 36px;
          letter-spacing: 0px;
          color: #253326;
        }
        ul{
          margin-top: 28px;
          li{
            font-family: PingFang-SC-Regular;
            font-size: 24px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 36px;
            letter-spacing: 0px;
            color: #253326;
          }
        }
      }
    }

    .swiper-pagination-box8 {
      display: flex;
      align-items: center;
      position: absolute;
      left: 50%;
      bottom: 0px;
      transform: translateX(-50%);
      background-color: #ffccdd;
    }
  }
  ::v-deep { 
    .swiper-pagination-bullet {
      width: 40px;
      height: 10px;
      background-color: #ffccdd;
      border-radius: 3px;
    }
    .swiper-pagination-bullet.swiper-pagination-bullet-active {
      width: 40px;
      height: 10px;
      background-color: #ff6699;
      border-radius: 5px;
    }
  }
}
</style>